import React from 'react';
import { FaSitemap } from 'react-icons/fa';
import { CodeListItem } from 'app/area/codetable/list/types-store';
import styles from './code-drag-preview.scss';

export const renderCodeDragPreview =
  (codeItem: CodeListItem) =>
    !!codeItem && <div className={styles.dragPreview}>
      <div className={styles.container}>
        <div className={styles.content}>
          {codeItem.description}
          {!!codeItem.childrenCount &&
            <span className={styles.childrenCount}>
              <FaSitemap /> {codeItem.childrenCount}
            </span>}
        </div>
      </div>
    </div>;
